import type {DateTimeModel} from '../../../../../core/domain/Date/DateTime.model';
import type {MetricModel} from '../../../../../core/domain/Metric/Metric.model';

export abstract class TrackWeightCmd {
  abstract exec(props: TrackWeightCmd.Props): Promise<TrackWeightCmd.Response>;
}

export namespace TrackWeightCmd {
  export type Props = {
    date: DateTimeModel;
    weightKg: number;
  };
  export type Response = MetricModel;
}
